<template>

	<widget title="Search Company Directory" icon="fa-search"  :max-height="maxHeight">
		<search-bar 
			v-on:submit="search"
			v-on:clearSearch="users = []" 
			placeholder="Search directory for people..." 
			:full-width="true">
		</search-bar>

		<table-list
			v-if="users.length > 0"
			:records="mutatedUsers"
			:fields="fields"
			record-name="User"
			:clickable-row="true"
			has-edit="/employee/{?}/profile"
			id-field="slug"
			edit-button-text="View"
			edit-button-icon="fa fa-eye">
		</table-list>
	</widget>

</template>

<script>
import TableList from "../TableList"
import SearchBar from "../SearchBar"
import Widget from "../Widget"

export default {

	name: 'EmployeeSearchWidget',
	components: {
		TableList,
		SearchBar,
		Widget
	},
	props: ["maxHeight"],
	data() {
		return {
			users: [],
			searchTerms: "",
			fields: [
				{label: "Name",key:"fullName",type:"link"},
				{label: "Title",key:"title"},
				{label: "Email",key:"email",showOnMobile: false}
			]
		}
	},
	computed: {
		mutatedUsers() {
			return this.users.map(user => {
				user.fullName = {
					text: user.first_name+" "+user.last_name,
					link: "/employee/"+user.slug+"/profile"
				}

				user.title = ""
				if ("EmployeeClassification" in user && user.EmployeeClassification.length > 0)
					user.title = user.EmployeeClassification[0].title

				return user
			})
		}
	},
	methods: {
		search(terms) {
			let vm = this

			vm.spinner("true")

			terms = encodeURIComponent(terms)

			let filters = JSON.stringify([
				["first_name",terms,"and","like"],
				["last_name",terms,"or","like"],
				["address",terms,"or","like"],
				["city",terms,"or","like"],
				["phone",terms,"or","like"],
				["email",terms,"or","like"]
			])

			let include = JSON.stringify(["EmployeeClassification"])

			vm.getJSON("User/get?filters="+filters+"&include="+include).then(response => {
				vm.users = response.data
				vm.spinner(false)
			})
		}
	}

}
</script>

<style>

	h2 {
		font-size: 20pt;
		color: #455A64 
	}

	.card .card-header h3 {
		margin: 0;
		text-decoration: none;
	}
</style>
